import React from 'react';

import styles from './fundProfileAllocatorDashboardStyles';

import MessageFundModal from 'buyside/components/presentation/FundProfileShowPage/MessageFundModal/messageFundModal';

const FundProfileAllocatorDashboard = ({
  currentEmployerName,
  fundName,
  sendMessage,
  viewCount
}) => {
  return (
    <div className={styles.dashboard}>
      <h4 className={styles.dashboardTitle}>Contact This Fund</h4>
      <MessageFundModal
        allocatorName={currentEmployerName}
        fundName={fundName}
        sendMessage={sendMessage}
        viewCount={viewCount}
      />
    </div>
  );
};

export default FundProfileAllocatorDashboard;
